import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { Button, Icon, Modal } from 'antd';

import * as actions from '../../actions';

import s from './styles.less';

const { confirm } = Modal;

const propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  planId: PropTypes.number.isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  email: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  sent: PropTypes.bool,
  sending: PropTypes.bool,
  className: PropTypes.string,
};
const defaultProps = {
  sent: false,
  sending: false,
  className: null,
};

const EmailQuoteButton = ({ sending, sent, className, onClick }) => {
  const icon = sent ? 'check-circle' : 'mail';
  return (
    <Button
      htmlType="button"
      type="primary"
      disabled={sending}
      onClick={onClick}
      className={className}
      size="large"
      ghost
    >
      <span className={s.icon}>
        <Icon type={sending ? 'loading' : icon} />
      </span>
      <span>{sent ? 'Quote emailed' : 'Email Quote'}</span>
    </Button>
  );
};

EmailQuoteButton.propTypes = propTypes;
EmailQuoteButton.defaultProps = defaultProps;

const mapStateToProps = ({ quote: { emailQuote } }) => ({
  sending: emailQuote.sending,
});

export default compose(
  connect(
    mapStateToProps,
    {
      emailQuote: actions.emailQuote,
    },
  ),
  withHandlers({
    onClick: ({ emailQuote, sent, email, planId }) => () => {
      const title = sent ? 'Resend Quote' : 'Email Quote';
      const message = sent
        ? 'This quote has already been sent to the recipient, please confirm if you would like to resend it.'
        : 'Is this the correct email address?';

      confirm({
        ...(sent && { width: 500 }),
        okText: 'Send',
        title,
        content: (
          <Fragment>
            <div>{message}</div>
            <div>
              <b>{email}</b>
            </div>
          </Fragment>
        ),
        onOk: () => emailQuote(planId),
      });
    },
  }),
)(EmailQuoteButton);
